import React, { useState } from "react";
import { useEffect } from "react";
import { useLanguageContext } from "./languageContext";
import {
  Grid,
  Box,
  IconButton,
  Typography,
  Modal,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const LANGUAGE_IMG_URL = import.meta.env.VITE_LANGUAGE_IMG_URL;

import axios from "axios";
import { useTranslation } from "react-i18next";
interface LanguageList {
  langId: number;
  languageName: string;
  languageCode: string;
  languageCountryFlag: string;
}

const LangSelect: React.FC = () => {
  const {
    i18next,
    isLanguage,
    setLanguage,
    onClickLanguageChange,
    setDefaultLanguage,
  } = useLanguageContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  const { t } = useTranslation();


  const [isAllLanguageData, setAllLanguageData] = useState<
    LanguageList[] | null
  >(null);

  //Language Json Data Fetch
  useEffect(() => {
    const fetchLanguageJsonData = async () => {
      try {
        const response = await axios.get(API_BASE_URL + "languages");
        if (response.status >= 200 && response.status <= 300) {
          setAllLanguageData(response.data.data);
          const lngValue = localStorage.getItem("lng");
          if (lngValue) {
            const findLangCode = response.data.data.find(
              (item: any) => item.languageCode === lngValue
            );
            if (findLangCode) {
              setLanguage(findLangCode);
              setDefaultLanguage(findLangCode.langId);
              await onClickLanguageChange(
                findLangCode.languageCode,
                findLangCode.langId
              );
            }
          } else {
            const setInitalLang = response.data.data.find(
              (item: any) => item.languageCode === "en-US"
            );
            if (setInitalLang) {
              setLanguage(setInitalLang);
              setDefaultLanguage(setInitalLang.langId);
              await onClickLanguageChange(
                setInitalLang.languageCode,
                setInitalLang.langId
              );
            }
          }
        }
      } catch (error) {
        console.error("Error fetching the JSON data:", error);
      }
    };
    fetchLanguageJsonData();
  }, []);

  const chooseLanguageHandler = () => {
    if (dialogOpen === true) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
  };

  const handleLanguageSelect = async (selectedLang: LanguageList) => {
    // Then delay the language change slightly
    setTimeout(async () => {
      setLanguage(selectedLang);

      await onClickLanguageChange(
        selectedLang.languageCode,
        selectedLang.langId
      );
    });

    handleLangClose(); // First close the dialog
  };

  const handleLangClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <style>
        {`
    .lang-header {
      background-color: #1972d6;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      color: white;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }

    .lang-title {
      font-weight: bold;
      font-size: 18px;
      letter-spacing: 1px;
    }

    .lang-dropdown {
      display: flex;
      flex-direction: column;
      padding: 0;
    }

    .lang-option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 18px;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      transition: background 0.3s;
    }

    .lang-option:hover {
      background-color: #f5f5f5;
    }

    .lang-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .lang-left img {
      width: 26px;
      height: 18px;
      border-radius: 2px;
    }

    .lang-radio {
      width: 18px;
      height: 18px;
      border: 2px solid #ccc;
      border-radius: 50%;
    }

    .lang-option.selected .lang-radio {
      background-color: #1972d6;
      border-color: #ccc;
    }
.language_dialog .MuiDialog-paperScrollPaper {
  width: 100%;
  max-width: 600px;
  min-width: 320px;
  max-height: 70vh;
  border-radius: 20px;
  overflow-y: auto;
}

/* For full HD screens */
@media (min-width: 1920px) {
  .language_dialog .MuiDialog-paperScrollPaper {
    max-width: 800px;
    max-height: 85vh;
  }
}

/* For 2K or ultra-wide screens */
@media (min-width: 2500px) {
  .language_dialog .MuiDialog-paperScrollPaper {
    max-width: 1000px;
  max-height: 100vh;

  }
}

@media (max-width: 768px) {
  .language_dialog .MuiDialog-paperScrollPaper {
    width: 95% !important;
    max-height: 90vh;
  }
}

@media (max-width: 480px) {
  .language_dialog .MuiDialog-paperScrollPaper {
    width: 95% !important;
    max-height: 95vh;
    border-radius: 16px;
  }
}

  `}
      </style>

      <Grid className="sele_lang">
        <Grid
          onClick={chooseLanguageHandler}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            padding: 0.5,
            background: "#fbf6f669",
            border: "1px solid #e9e9e9",
            borderRadius: "10px",
          }}
        >
          <Box
            component="img"
            alt={isLanguage?.languageCountryFlag}
            src={LANGUAGE_IMG_URL + `${isLanguage?.languageCountryFlag || ""}`}
            width={24}
            height={16}
            sx={{
              // width: 24,
              // height: 16,
              objectFit: "cover",
              borderRadius: "2px",
              marginRight: 1,
            }}
          />
          <Typography
            variant="body2"
            sx={{
              color: "text.primary",
              fontSize: "14px",
              fontWeight: "500",
              marginRight: 1,
            }}
          >
            {isLanguage ? isLanguage.languageName : i18next.language}
          </Typography>

          <IconButton>
            <KeyboardArrowDownIcon />
          </IconButton>
        </Grid>

        <Modal
          open={dialogOpen}
          onClose={handleLangClose}
          aria-labelledby="language-modal"
          aria-describedby="language-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              borderRadius: "20px",
              width: "90%",
              maxWidth: "600px",
              maxHeight: "70vh",
              overflowY: "auto",
              boxShadow: 24,
            }}
            className="language_modal"
          >
            <Box className="lang-header">
              <Typography className="lang-title">
                {t("choose_language")}
              </Typography>
              <Box>
                <IconButton
                  onClick={handleLangClose}
                  sx={{
                    color: "white",
                    padding: 0.5,
                    border: "1px solid #fff",
                    borderRadius: "50px",
                    transition: "0.3s ease-out",
                    ":hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)", // optional hover effect
                    },
                  }}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>

            <Box
              className="dialog_section"
              sx={{
                maxHeight: "60vh",
                overflowY: "auto",
                padding: 2,
              }}
            >
              <Box className="lang-dropdown">
                {isAllLanguageData?.map((lng) => (
                  <Box
                    key={lng.languageCode}
                    className={`lang-option ${lng.languageCode === i18next.language ? "selected" : ""}`}
                    onClick={() => handleLanguageSelect(lng)}
                  >
                    <Box className="lang-left">
                      <img
                        src={LANGUAGE_IMG_URL + lng.languageCountryFlag}
                        alt={lng.languageName}
                      />
                      <Typography>{lng.languageName.toUpperCase()}</Typography>
                    </Box>
                    <Box className="lang-radio" />
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Modal>
      </Grid>
    </>
  );
};

export default LangSelect;
